// GTM dataLayer köprüsü — sinav.uz'daki lib/analytics.ts ile aynı olay
// isimlerini kullanır, ki iki sitenin hunisi tek GA4 raporunda birleşsin.

export function track(event, params = {}) {
    if (typeof window === 'undefined') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
}
